<template>
        <BreadCrumb PageTitle=" Ajouter un marchand" />

    <AddUsager />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddUsager from "@/components/Usager/AddUsager.vue";
  
    export default defineComponent({
      name: "AddUsagerPage",
      components: {
        BreadCrumb,
        AddUsager,
      },
    });
  </script>